<div class="widget-content-inner" [ngClass]="{'centerForMobile': isMobile}">
  <div class="row">
    <div class="col">
      <div class="checkout-summary-box">
        <h3 style="text-align: center; width: 100%; margin: 0 auto;">Summary</h3>
        <form class="wallet-deposit pt-3 centerCheckoutMobile">
          <div class="row">
            <div class="col" [ngClass]="{'adaptForMobile': isMobile}">
              <div class="credit-card summary-box-content">
                <h5 class="text-2">Your Tickets</h5>
                <div class="box-content compact">
                  <ul class="tf-social style-3 flex-wrap">
                    <li *ngFor="let number of selectedNumbers">
                      <a href="javascript:void(0)">
                        <i class="icon">{{ number }}</i>
                      </a>
                    </li>
                  </ul>
                </div>
                <h5 class="text-2">Your Voted Ticket</h5>
                <div class="box-content compact">
                  <ul class="tf-social style-3 flex-wrap">
                    <li *ngFor="let number of votedTicketNumbers">
                      <a href="javascript:void(0)">
                        <i class="icon">{{ number }}</i>
                      </a>
                    </li>
                  </ul>
                </div>
                <h5 class="text-2" style="align-self: center">
                  You will pay {{ purchaseCostInUsd }} €
                </h5>
                <div class="payment-methods">
                  <div class="form-check" style="display: flex;">
                    <input class="form-check-input" type="radio" name="paymentMethod" id="cardPayment"
                      [(ngModel)]="selectedPaymentMethod" value="card" checked>
                    <label class="form-check-label" for="cardPayment">
                      <i class="fas fa-credit-card"></i> Card
                    </label>
                  </div>
                  <div class="form-check" style="display: flex;">
                    <input class="form-check-input" type="radio" name="paymentMethod" id="paypalPayment"
                      [(ngModel)]="selectedPaymentMethod" value="paypal">
                    <label class="form-check-label" for="paypalPayment">
                      <i class="fas fa-credit-card"></i> Paypal
                    </label>
                  </div>
                  <div class="form-check" style="display: flex;">
                    <input class="form-check-input" type="radio" name="paymentMethod" id="cryptoPayment"
                      [(ngModel)]="selectedPaymentMethod" value="crypto">
                    <label class="form-check-label" for="cryptoPayment" [ngClass]="{'ineritForM': isMobile}">
                      <i class="fas fa-wallet"></i> Crypto (Web3)
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Metodi di Pagamento -->
    <div class="col-md-6">
      <h3 *ngIf="isTryMode" style="text-align: center; width: 100%; margin: 0 auto;">Your journey is completed!<br />In the real version of the game, you'll pay here.</h3>

      <ng-container *ngIf="!isTryMode">
        <h3 style="text-align: center; width: 100%; margin: 0 auto;">Payment's Informations</h3>
        <!-- Pagamento con carta -->
        <div *ngIf="selectedPaymentMethod === 'card'">
          <form class="wallet-deposit pt-3 centerCheckoutMobile" [formGroup]="checkoutCardForm">
            <div class="row">
              <div class="col">
                <div class="credit-card">
                  <div class="card-input card-number">
                    <label for="card-element" class="text-2">Card Details</label>
                    <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                      <ngx-stripe-card [options]="cardOptions" (change)="onCardChange($event)" />
                    </ngx-stripe-elements>
                  </div>
                  <div class="card-input name">
                    <label for="card-name" class="text-2">Card Name</label>
                    <div class="content-input">
                      <input formControlName="cardName" type="text" class="currency-input" placeholder="JOHN DOE">
                    </div>
                  </div>

                  <button type="submit" class="tf-btn full-w" [disabled]="!checkoutCardForm.valid || !isCardValid"
                    [ngClass]="{ 'style-1': checkoutCardForm.valid && isCardValid, 'style-3': !checkoutCardForm.valid || !isCardValid }"
                    (click)="onCheckoutCardSubmit()">
                    {{'Confirm Purchase'}}
                  </button>
                  <div class="note">
                    <div class="text">
                      Please, keep in mind that 3-D Secure code can be requested several times in order to process
                      the deposit transaction.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Pagamento con Paypal -->
        <div *ngIf="selectedPaymentMethod === 'paypal'">
          <form class="wallet-deposit pt-3 centerCheckoutMobile">
            <div class="row">
              <div class="col">
                <div class="credit-card">

                  <button type="submit" class="tf-btn full-w" (click)="onCheckoutPaypalSubmit()">
                    {{'Confirm Purchase'}}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Pagamento con cripto -->
        <div *ngIf="selectedPaymentMethod === 'crypto'">
          <form class="wallet-deposit pt-3 centerCheckoutMobile" [formGroup]="checkoutWalletForm">
            <div class="row">
              <div class="col">
                <div class="credit-card">
                  <div class="card-input card-number">
                    <label for="outbound-transaction-wallet" class="text-2">
                      Web3 Wallet Address from your payment will come
                    </label>
                    <fieldset class="content-input">
                      <input formControlName="walletOutTrans" type="text" class="currency-input">
                    </fieldset>
                  </div>
                  <div class="card-input card-number">
                    <label for="inbound-transaction-wallet" class="text-2">
                      Web3 Wallet Address where you'll receive your prizes
                    </label>
                    <fieldset class="content-input">
                      <input formControlName="walletInbTrans" type="text" class="currency-input">
                    </fieldset>
                  </div>
                  <button *ngIf="!isWalletConnected" class="tf-btn full-w" (click)="onConnectWallet()" type="button"
                    [ngClass]="{ 'style-1': checkoutWalletForm.valid, 'style-3': !checkoutWalletForm.valid }"
                    [disabled]="!checkoutWalletForm.valid">Connect your wallet</button>
                  <button *ngIf="isWalletConnected" class="tf-btn full-w" (click)="onPayWithWallet()" type="button"
                    [ngClass]="{ 'style-1': checkoutWalletForm.valid, 'style-3': !checkoutWalletForm.valid }"
                    [disabled]="!checkoutWalletForm.valid">Pay with your wallet</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-container>

    </div>
  </div>
</div>